<template>
  <div class="navbar" v-if="!hideNavbar">
    <div
      :class="['item', item.class]"
      v-for="(item, key) in items"
      :key="key"
      @click="$router.push(item.to)"
      :style="item.to === currentPath ? 'background-color: white' : ''"
    >
      <span :style="item.to === currentPath ? 'color: black' : ''">{{
        item.name
      }}</span>
    </div>

    <div class="last-activity" v-if="showLastActivity && lastVideo">
      Last activity:
      <hr />
      <div>
        <span>Show:</span>&nbsp;<span
          class="activity-item"
          @click="$router.push('/shows/' + lastVideo.showName)"
          >{{ lastVideo.showName }}</span
        >
      </div>
      <div>
        <span>Season:</span>&nbsp;<span
          class="activity-item"
          @click="
            $router.push(
              '/shows/' + lastVideo.showName + '/' + lastVideo.seasonName
            )
          "
          >{{ lastVideo.seasonName }}</span
        >
      </div>
      <div>
        <span>Episode:</span>&nbsp;<span
          class="activity-item"
          @click="$router.push('/watch/' + lastVideo.id)"
          >{{ lastVideo.name }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import config from "../config";

const HIDDEN_NAVBAR_ROUTES = ["watch"];
const token = localStorage.getItem("token");

export default {
  props: {
    session: Object
  },
  data() {
    return {
      items: [
        {
          name: "Shows",
          to: "/shows",
          class: "shows"
        },
        {
          name: "Upload File",
          to: "/upload",
          class: "upload"
        },
        {
          name: "Upload Show",
          to: "/upload_show",
          class: "upload-show"
        },
        {
          name: "Authenticate",
          to: "/authenticate",
          class: "authenticate"
        },
        {
          name: "Playing",
          to: "/playing",
          class: "playing"
        }
      ],
      currentPath: this.$route.path,
      hideNavbar: false,
      showLastActivity: true,
      lastVideo: null
    };
  },
  methods: {
    checkHideNavbar() {
      const routeRoot = this.currentPath.split("/")[1];

      this.hideNavbar = HIDDEN_NAVBAR_ROUTES.includes(routeRoot);
    },
    getLastActivity() {
      if (this.session.lastVideoId)
        this.axios
          .get(config.api + "/episodes/" + this.session.lastVideoId, {
            headers: {
              authorization: token
            }
          })
          .then(result => {
            this.lastVideo = result.data;
          });
    }
  },
  watch: {
    $route: function() {
      this.currentPath = this.$route.path;

      this.showLastActivity = false;

      this.checkHideNavbar();
    }
  },
  created() {
    this.checkHideNavbar();
    this.getLastActivity();
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.navbar {
  width: 100%;

  display: flex;
}

.navbar > .item {
  margin: 0 10px 0 10px;
  padding: 10px;

  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  border: 2px solid white;
  border-top: none;

  cursor: pointer;
}

.last-activity {
  position: absolute;
  right: 0;
  top: 0;

  margin: 0 10px 0 10px;
  padding: 10px;

  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  border: 2px solid white;
  border-top: none;
}

.last-activity > div {
  display: flex;
  justify-content: space-between;
  padding: 2px 0;
}

.activity-item {
  text-decoration: underline;
  cursor: pointer;
}

.upload,
.upload-show {
  /* display: none; */
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue